<script setup lang="ts">
export type BlocksInterface = (Record<string, unknown> & { __typename: string })

interface BlocksRendererProps {
  blocks?: (BlocksInterface | null)[] | null
}

defineProps<BlocksRendererProps>()

const blockComponent = new Map([
  ['blockBanner_Entry', resolveComponent('LazyBlockBanner')],
  ['blockCards_Entry', resolveComponent('LazyBlockCards')],
  ['blockContactForm_Entry', resolveComponent('LazyBlockContactForm')],
  ['blockCta_Entry', resolveComponent('LazyBlockCta')],
  ['blockGrid_Entry', resolveComponent('LazyBlockGrid')],
  ['blockHero_Entry', resolveComponent('LazyBlockHero')],
  ['blockHighlights_Entry', resolveComponent('LazyBlockHighlights')],
  ['blockMedia_Entry', resolveComponent('LazyBlockMedia')],
  ['blockMediaSlider_Entry', resolveComponent('LazyBlockMediaSlider')],
  ['blockProductReview_Entry', resolveComponent('LazyBlockProductReview')],
  ['blockSpotlight_Entry', resolveComponent('LazyBlockSpotlight')],
  ['blockText_Entry', resolveComponent('LazyBlockText')],
  ['blockTiles_Entry', resolveComponent('LazyBlockTiles')],
])
</script>

<template>
  <div v-if="blocks && blocks.length > 0" class="blocks">
    <component
      :is="blockComponent.get(block!.__typename)"
      v-for="(block, i) in blocks"
      :key="i"
      :data="block"
    />
  </div>
</template>
